$('.o-select select').each(function () {
    var $this = $(this), numberOfOptions = $(this).children('option').length;

    var search_enable = $this.attr('data-search') == 'true';

    var $search = false;
    var $empty = false;


    // validation hack
    $this.on('change', function () {
        $this.removeAttr('required')
            .parents('.m-form-validate-line').removeClass('has-error').addClass('has-no-error')
            .next().remove();
    });


    $this.addClass('o-select--hidden');
    $this.wrap('<div class="o-select-in"></div>');

    var $parent = $this.parents('.o-select');
    var $first_parent = $parent.parent();

    //if enable live search
    if (search_enable) {
        $this.after('<div class="o-select-search"><input type="text" placeholder="Start typing..." /></div>');
        $this.after('<div class="o-select-empty">No results found</div>');
        $search = $parent.find('input');
        $empty = $parent.find('.o-select-empty');
    }

    $this.after('<div class="o-select--styled"></div>');

    var $styledSelect = $this.next('div.o-select--styled');
    $styledSelect.text($this.children('option:selected').eq(0).text());

    var $list = $('<ul />', {
        'class': 'o-select-options u-shadow--base'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            class: $this.children('option').eq(i).attr('class'),
            'data-id': $this.children('option').eq(i).attr('data-id'),
            'data-value': $this.children('option').eq(i).val()
        }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.o-select--styled.is-active').not(this).each(function () {
            $(this).removeClass('is-active').next('ul.o-select-options').hide();
        });
        $(this).toggleClass('is-active').next('ul.o-select-options').toggle();

        //if enable live search
        if (search_enable) {
            $parent.toggleClass('is-shown');
            $first_parent.toggleClass('is-active');
            //$('body').toggleClass('search-active');
            $search.focus();
        }
    });

    $listItems.click(function (e) {
        e.stopPropagation();
        var text = $(this).text();
        $listItems.removeAttr('selected');
        $styledSelect.text(text).removeClass('is-active');
        $this.val($(this).attr('rel'));
        $this.val($(this).data('value'));
        $this.trigger('change');
        // $this.val($(this).attr('selected', 'selected'));
        $list.hide();
        //if enable live search
        if (search_enable) {
            $parent.removeClass('is-shown');
            $first_parent.removeClass('is-active');
            //$('body').removeClass('search-active');
            $listItems.removeClass('is-closed');
            $search.val(text);

        }
    });

    $(document).click(function () {
        $styledSelect.removeClass('is-active');
        $list.hide();

        //if enable live search
        if (search_enable) {
            $parent.removeClass('is-shown');
            $first_parent.removeClass('is-active');
            //$('body').removeClass('search-active');
            $listItems.removeClass('is-closed');
            $empty.hide();
        }
    });

    //live search
    if (search_enable) {
        var values = [];
        $listItems.each(function (i, el) {
            values.push($(el).text());
        });
        $search.on('input', function () {
            var value = $(this).val().toLowerCase();
            $empty.hide();//hide 'No matches'
            if (value.length > 0) {
                for (var j = 0; j < values.length; j++) {
                    if (!(value.substring(0, value.length) === values[j].substring(0, value.length).toLowerCase())) {
                        $listItems.filter(':eq(' + j + ')').addClass('is-closed');
                        //show 'No matches'
                        if ($listItems.filter('.is-closed').length == $listItems.length) $empty.show();
                    } else $listItems.filter(':eq(' + j + ')').removeClass('is-closed');
                }
            } else $listItems.removeClass('is-closed');
        });
    }
});

// contact page

$(".js-o-select-issue li").on("click", function () {

    var $id = $(this).data("id");
    var $this = $("#" + $id);
    $('.js-o-select-result').addClass('u-none').find('select').prop('required', false).prop('disabled', true).parents('.m-form-validate-line').removeClass('has-error has-no-error').next().remove();

    if ($this.hasClass('u-none')) {
        $this.removeClass('u-none').find('select').prop('required', true).prop('disabled', false);
    }
});

$(".js-o-select-profile li").on("click", function () {

    var $id = $(this).data("id");
    var $this = $("#" + $id);
    var $default = $('.js-o-select-profile--target');


    if ($id == 'cancel') {
        $('.js-o-select-profile-disable').parent().addClass('u-disabled u-opacity--two');
        $('.js-c-contact-submit').addClass('u-disabled u-opacity--two');
    } else {
        $('.js-o-select-profile-disable').parent().removeClass('u-disabled u-opacity--two');
        $('.js-c-contact-submit').removeClass('u-disabled u-opacity--two');
    }

    $default.addClass('u-none');
    if ($this.hasClass('u-none')) {
        $this.removeClass('u-none');
    } else {
        $this.addClass('u-none');
    }
});


